import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {StatusDot} from 'shells/status-selector/status-dot';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {AgentStatusEnum} from 'nutshell-graphql-types';
import type {GetAgents_chatAgents as Agent} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../../../core/use-get-session-user';

import {useUpdateAgentStatus} from '../../graphql/hooks';

type Props = {
    agent: Agent;
};

export function AgentStatusTableEntry(props: Props) {
    const {updateAgentStatus} = useUpdateAgentStatus();
    const {user} = useGetSessionUser();

    const handleStatusChange = (newStatus: AgentStatusEnum) => {
        updateAgentStatus({
            agentStatus: newStatus === 'ONLINE' ? 'ONLINE' : 'NOT_ACCEPTING_CHATS',
            userId: props.agent.id,
        });
    };

    const isOnline = props.agent.agentPresence === 'ONLINE';
    const isReadOnly = Boolean(user && props.agent.id !== user.id && !isOnline);

    return (
        <div className='flex gap-8 justify-sb full-width mr-8'>
            <StackLegacy spacing={6} isHorizontal={true} alignCenter={true}>
                <StatusDot color={isOnline ? colors.success : colors.greyLt} size={12} />
                <Body>{isOnline ? 'Available' : 'Not accepting chats'}</Body>
            </StackLegacy>
            <Switch
                isOn={isOnline}
                onChange={() => handleStatusChange(isOnline ? 'NOT_ACCEPTING_CHATS' : 'ONLINE')}
                isRounded={true}
                isSmall={true}
                isDisabled={isReadOnly}
            />
        </div>
    );
}
